import { createContext, useContext } from 'react';

interface InternalSheetContext {
  isOpen: boolean
  setIsSheetOpen: (isOpen: boolean) => void
}

const InternalSheetContext = createContext<
  InternalSheetContext | undefined
>(undefined)

const InternalSheetContextProvider = InternalSheetContext.Provider

export const useInternalSheetContext = () => {
  const context = useContext(InternalSheetContext)

  if (context === undefined) {
    throw new Error(
      'useInternalSheetContext must be used within a InternalSheetProvider'
    )
  }

  return context
}

export const InternalSheetProvider = ({ value, children }) => {
  return (
    <InternalSheetContextProvider value={value}>
      {children}
    </InternalSheetContextProvider>
  )
}

InternalSheetProvider.displayName = 'InternalSheetProvider'
